import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import styles from '../assets/css/login.module.css';
import logo from '../assets/images/polyglow-logo.svg';
import { loginIcons } from '../assets/images/login';
import { login as loginApi } from "../services/auth";


const LogIn = () => {


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [forgetEmail, setForgetEmail] = useState('');
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

const handleLoginSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (!email || !password) {
    setError("Merci de renseigner email et mot de passe.");
    return;
  }

  try {
    // Appel à l'API backend (services/auth.js)
    await loginApi({ identifier: email, password });

    // services/auth.js se charge déjà de mettre isLoggedIn + tokens en localStorage
    navigate("/themeSelector");
  } catch (err) {
    console.error(err);
    setError("Identifiants incorrects");
  }
};


  const handleForgetSubmit = () => {
    console.log('Send reset email to:', forgetEmail);
    setShowModal(false);
  };

  return (
    <div className={styles.logPage}>
      <header className={styles.homeHeader}>
        <a className={styles.logoAnaimation} href="/">
          <img src={logo} className={styles.logoPolyglow} alt="Logo Polyglowth" />
        </a>
      </header>

      <div className={styles.content}>
        <div className={styles.title}>
          <h1>hello,</h1>
          <p>Connectez-vous à votre compte</p>
        </div>

        <form className={styles.logInputs}>
          <div className={styles.overlap}>
            <img className={styles.icon} src={loginIcons.user} alt="User Icon" />
            <input
              type="email"
              id="AdresseEmail"
              name="AdresseEmail"
              placeholder="Adresse email"
              required
              className={styles.jade}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className={styles.overlap}>
            <img className={styles.icon} src={loginIcons.lock} alt="Lock Icon" />
            <input
              type={showPassword ? 'text' : 'password'}
              id="MotDePasse"
              name="MotDePasse"
              placeholder="Mot de passe"
              required
              className={styles.textWrapper3}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              className={styles.solidStatusEye}
              src={showPassword ? loginIcons.eyeCrossed : loginIcons.eye}
              alt="Eye Icon"
              onClick={togglePasswordVisibility}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <a href="#" className={styles.forgetPassword} onClick={(e) => { e.preventDefault(); setShowModal(true); }}>
            Mot de passe oublié ?
          </a>

          <button type="submit" id="Envoyer" className={styles.signIn} onClick={handleLoginSubmit} style={{ cursor: 'pointer' }}>
            <p>Se connecter</p>
            <div className={styles.iconWrapper}>
              <img className={styles.icon2} src={loginIcons.arrow} alt="Connexion" />
            </div>
          </button>
          {error && <p className="error">{error}</p>}
        </form>

        <div className={styles.vectorsDeco}>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade open" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myModalLabel">Veuillez saisir votre adresse e-mail</h5>
              </div>
              <div className="modal-body">
                <input
                  type="email"
                  name="forget-mail"
                  id="forget-mail"
                  value={forgetEmail}
                  onChange={(e) => setForgetEmail(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="send btn-full" onClick={handleForgetSubmit}>Envoyer</button>
                <button type="button" className="cancel btn-empty" onClick={() => setShowModal(false)}>Annuler</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogIn;


/* import { useState } from 'react';
import { motion } from 'framer-motion';
import '../assets/css/login.module.css';
import logo from '../assets/images/polyglowth-logo.svg';
import { loginIcons } from '../assets/images/login';

const LogIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [forgetEmail, setForgetEmail] = useState('');

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    // send login request
    console.log('Email:', email, 'Password:', password);
  };

  const handleForgetSubmit = () => {
    console.log('Send reset email to:', forgetEmail);
    setShowModal(false);
  };

  return (
    <div id="logPage">
      <header id="homeHeader">
        <a className="logo-anaimation" href="/">
          <img src={logo} className="logo-anaimation" alt="Logo Polyglowth" />
        </a>
      </header>

      <div className="content">
        <div className="title">
          <h1>hello,</h1>
          <p>Connectez-vous à votre compte</p>
        </div>

        <form className="log-inputs" onSubmit={handleLoginSubmit}>
          <div className="overlap">
            <img className="icon" src={loginIcons.icon} alt="User Icon" />
            <input
              type="email"
              id="AdresseEmail"
              name="AdresseEmail"
              placeholder="Adresse email"
              required
              className="jade"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="overlap">
            <img className="icon" src={loginIcons.lock} alt="Lock Icon" />
            <input
              type={showPassword ? 'text' : 'password'}
              id="MotDePasse"
              name="MotDePasse"
              placeholder="Mot de passe"
              required
              className="text-wrapper-3"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              className="solid-status-eye"
              src={showPassword ? loginIcons.eye : loginIcons.eye}
              alt="Eye Icon"
              onClick={togglePasswordVisibility}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <a href="#" className="forget-password" onClick={(e) => { e.preventDefault(); setShowModal(true); }}>
            Mot de passe oublié ?
          </a>

          <button type="submit" id="Envoyer" className="sign-in" style={{ cursor: 'pointer' }}>
            <p>SE CONNECTER</p>
            <div className="icon-wrapper">
              <img className="icon-2" src={loginIcons.icon1} alt="Connexion" />
            </div>
          </button>
        </form>

        <div className="vectors-deco">
          <div className="vector"></div>
          <div className="vector"></div>
          <div className="vector"></div>
          <div className="vector"></div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade open" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myModalLabel">Veuillez saisir votre adresse e-mail</h5>
              </div>
              <div className="modal-body">
                <input
                  type="email"
                  name="forget-mail"
                  id="forget-mail"
                  value={forgetEmail}
                  onChange={(e) => setForgetEmail(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="send btn-full" onClick={handleForgetSubmit}>Envoyer</button>
                <button type="button" className="cancel btn-empty" onClick={() => setShowModal(false)}>Annuler</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogIn; */